import 'css-chunksrc/client/scenes/documentUpdate/styles.scss';export default {
  "updateDocument": "_updateDocument_lemq2_1",
  "main": "_main_lemq2_8",
  "buttons": "_buttons_lemq2_20"
};